import {patchState, signalStore, withMethods} from '@ngrx/signals';
import {
  addEntities,
  addEntity,
  removeAllEntities,
  removeEntities,
  removeEntity,
  setAllEntities,
  withEntities
} from '@ngrx/signals/entities';
import {Animal} from 'src/app/infrastructure/moovement-api/models/asset';

export const AnimalSelectionStore = signalStore(
  { providedIn: 'root' },
  withEntities<Animal>(),
  withMethods((store) => ({
    setAllEntities(animals: Animal[]) {
      patchState(store, setAllEntities(animals));
    },
    addEntities(animals: Animal[]) {
      patchState(store, addEntities(animals))
    },
    addEntity(animal: Animal) {
      patchState(store, addEntity(animal))
    },
    removeEntities(ids: string[]) {
      patchState(store, removeEntities(ids))
    },
    removeEntity(id: string) {
      patchState(store, removeEntity(id))
    },
    reset() {
      patchState(store, removeAllEntities());
    }
  }))
);
